import appConf from "../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];
const environment = process.env.NODE_ENV;
const project = "Contact Fetcher";
const server = null;
const service = null;
const initDate = new Date();
const initDateFormat = initDate.toISOString().split('T')[0]; // yyyy-mm-dd
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    contact: {
      api: {
        endpoints: {
          detail: {
            headers: {
              'Authorization': null,
            },
            doc: "http://tr4ns10.tr4ns.com/Westfield-BulkOrder/clients/{companyId}/contacts",
            url: setup.setup.api.westfield_v1.url[environment] + "/clients/",
            method: 'GET'
          }
        }
      }
    }
  },
  routes: {
    label: null,
    prefix: null
  },
  setup,
  environment
}

export default config;
